import { AbstractControl, AbstractControlOptions, ValidationErrors, ValidatorFn } from '@angular/forms';

import { EditorBookingItemSetting } from './editor-booking-item-setting.model';
import { EditorDataService } from '../editor-data/editor-data.service';


const settingValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  if (control.pristine) {
    return null;
  }

  return control.get('available').value !== null ? null : { invalidAvailable: true };
};


export class EditorBookingItemSettingCapacity extends EditorBookingItemSetting {
  settingClassName = 'Capacity';
  serializedName = 'capacities';
  showSummary = true;

  available: number;

  constructor(obj?: any) {
    super({
      inheritableType: obj?.inheritableType ?? null
    });
    this.available = obj?.available ?? null;
  }

  createCopy(): EditorBookingItemSettingCapacity {
    return new EditorBookingItemSettingCapacity({
      available: this.available,
      inheritableType: this.inheritableType
    });
  }

  getTitle(): string {
    return $localize `Capacity`;
  }

  getHelpText(): string {
    return $localize `How many places are available?`;
  }

  hasSummary(): boolean {
    return this.available !== null;
  }

  getFormConfig(_editorData: EditorDataService): {
    controlsConfig: { [key: string]: any; },
    options?: AbstractControlOptions
  } {
    return {
      controlsConfig: {
        available: [this.available]
      },
      options: {
        validators: settingValidator
      }
    };
  }

  getFormValues(): any {
    return {
      available: this.available
    };
  }

  getEmptyFormValues(): any {
    return {
      available: null
    };
  }

  applyFormValues(formValues: any) {
    this.available = formValues.available;
  }

  getSerializedValues(): any {
    return {
      availableCapacity: this.available
    };
  }
}
